import { createFileRoute } from '@tanstack/react-router'
import { ClientList } from '@/modules/client-knowledge/pages/ClientList'

export const Route = createFileRoute('/clients/')({
  component: ClientList,
})
